module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"variants_of":"Variants of","rearrange_your_variants":"Rearrange your variants "},"id":{"variants_of":"Varian untuk","rearrange_your_variants":"Atur varian "}}')
  delete Component.options._Ctor
}
